import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTransactions } from "../../store/dbInvoices/actions";
import TableContainer from "../../components/Common/TableContainer";
import TransactionModal from "./TransactionModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ar } from 'date-fns/locale';
import { format, parseISO, isWithinInterval, subDays } from 'date-fns';



import { Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter, Badge, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from 'xlsx';

const ResolvedTransferTransactions = () => {
  const transactions = useSelector(state => state.transactions.transactions);
  
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDateRangeModalOpen, setIsDateRangeModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [quickFilter, setQuickFilter] = useState('الكل');
  const [exportDropdownOpen, setExportDropdownOpen] = useState(false);

  const dispatch = useDispatch();






  useEffect(() => {
    dispatch(fetchTransactions());
  }, [dispatch]);

  // دالة لتحويل التاريخ إلى تنسيق عربي


  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const toggleDateRangeModal = () => setIsDateRangeModalOpen(!isDateRangeModalOpen);

  const handleRowClick = (transaction) => {
    setSelectedTransaction(transaction);
    toggleModal();
  };

  const applyQuickFilter = (range) => {
    setQuickFilter(range);
    let start = null;
    let end = null;
    
    switch(range) {
      case 'اليوم':
        start = new Date();
        start.setHours(0, 0, 0, 0);
        end = new Date();
        break;
      case 'الأسبوع':
        start = subDays(new Date(), 7);
        break;
      case 'الشهر':
        start = subDays(new Date(), 30);
        break;
      default:
        // 'الكل' أو غير ذلك
        break;
    }
    
    setDateRange([start, end]);
  };

  const applyDateFilter = () => {
    toggleDateRangeModal();
  };

  const clearFilters = () => {
    setDateRange([null, null]);
    setQuickFilter('الكل');
  };

  const filteredTransactions = useMemo(() => {
    return transactions.filter((transaction) => {
      // تصفية حسب حالة الدفع (مدفوع فقط)
      if (transaction.payment_status !== 'paid') return false;
      
      // تصفية حسب النطاق الزمني إذا تم تحديده
      if (startDate && endDate) {
        try {
          let transactionDate;
          
          // التعامل مع تنسيقات التاريخ المختلفة
          if (transaction.created_at?.seconds) {
            transactionDate = new Date(transaction.created_at.seconds * 1000);
          } else if (transaction.created_at) {
            transactionDate = parseISO(transaction.created_at);
          } else {
            return false;
          }
          
          return isWithinInterval(transactionDate, {
            start: startDate,
            end: endDate
          });
        } catch (error) {
          console.error('خطأ في تصفية التاريخ:', error);
          return false;
        }
      }
      
      return true;
    });
  }, [transactions, startDate, endDate]);

  const toggleExportDropdown = () => setExportDropdownOpen(prevState => !prevState);

  // Format transaction date
  const formatTransactionDate = (date) => {
    if (!date) return 'غير متوفر';
    
    try {
      let parsedDate;
      
      if (typeof date === 'object' && 'seconds' in date) {
        parsedDate = new Date(date.seconds * 1000);
      } 
      else if (typeof date === 'string') {
        parsedDate = parseISO(date);
      }
      else if (date instanceof Date) {
        parsedDate = date;
      } else {
        return 'تاريخ غير صالح';
      }
      
      return format(parsedDate, 'yyyy/MM/dd HH:mm', { locale: ar });
    } catch (error) {
      console.error('خطأ في تحويل التاريخ:', error);
      return 'تاريخ غير صالح';
    }
  };

  // Export to Excel functions
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredTransactions.map(t => ({
      'تاريخ العملية': formatTransactionDate(t.created_at),
      'مقدم الخدمة': t.serviceProviders?.salon_name || 'غير متوفر',
      'المبلغ': `${t.total} ر.س`,
      'حالة الدفع': t.payment_status === 'paid' ? 'تم الدفع' : 'قيد الانتظار'
    })));
    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "الحوالات المكتملة");
    XLSX.writeFile(workbook, "الحوالات_المكتملة.xlsx");
  };

  const exportSingleToExcel = (transaction) => {
    const worksheet = XLSX.utils.json_to_sheet([{
      'رقم العملية': transaction.id,
      'تاريخ العملية': formatTransactionDate(transaction.created_at),
      'مقدم الخدمة': transaction.serviceProviders?.salon_name || 'غير متوفر',
      'المبلغ': `${transaction.total} ر.س`,
      'حالة الدفع': transaction.payment_status === 'paid' ? 'تم الدفع' : 'قيد الانتظار',
      'تاريخ التنفيذ': transaction.booking_execute_date ? formatTransactionDate(transaction.booking_execute_date) : 'غير محدد'
    }]);
    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "فاتورة");
    XLSX.writeFile(workbook, `فاتورة_${transaction.id}.xlsx`);
  };

  // Export to PDF functions
  const exportToPDF = () => {
    const doc = new jsPDF();
    
    doc.setFontSize(18);
    doc.text("الحوالات المكتملة", 105, 15, { align: 'center' });
    
    if (startDate || endDate) {
      doc.setFontSize(12);
      doc.text(
        `الفترة: ${startDate ? format(startDate, 'yyyy/MM/dd') : '...'} إلى ${endDate ? format(endDate, 'yyyy/MM/dd') : '...'}`,
        105,
        25,
        { align: 'center' }
      );
    }
    
    const headers = [['تاريخ العملية', 'مقدم الخدمة', 'المبلغ', 'حالة الدفع']];
    const data = filteredTransactions.map(t => [
      formatTransactionDate(t.created_at),
      t.serviceProviders?.salon_name || 'غير متوفر',
      `${t.total} ر.س`,
      t.payment_status === 'paid' ? 'تم الدفع' : 'قيد الانتظار'
    ]);
    
    autoTable(doc, {
      head: headers,
      body: data,
      startY: 30,
      styles: {
        font: 'helvetica',
        halign: 'center'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: [255, 255, 255]
      }
    });
    
    doc.save("الحوالات_المكتملة.pdf");
  };

  const exportSingleToPDF = (transaction) => {
    const doc = new jsPDF();
    
    doc.setFontSize(18);
    doc.text("تفاصيل الحوالة", 105, 15, { align: 'center' });
    
    doc.setFontSize(12);
    let y = 30;
    
    const details = [
      ['رقم العملية', transaction.id],
      ['تاريخ العملية', formatTransactionDate(transaction.created_at)],
      ['مقدم الخدمة', transaction.serviceProviders?.salon_name || 'غير متوفر'],
      ['المبلغ', `${transaction.total} ر.س`],
      ['حالة الدفع', transaction.payment_status === 'paid' ? 'تم الدفع' : 'قيد الانتظار'],
      ['تاريخ التنفيذ', transaction.booking_execute_date ? formatTransactionDate(transaction.booking_execute_date) : 'غير محدد']
    ];
    
    details.forEach(([label, value]) => {
      doc.text(`${label}: ${value}`, 20, y);
      y += 10;
    });
    
    doc.save(`حوالة_${transaction.id}.pdf`);
  };

  // ... (keep all your existing functions like toggleModal, handleRowClick, etc.)

  








  const columns = useMemo(
    () => [
      {
        Header: "تاريخ العملية",
        accessor: "created_at",
        Cell: ({ value }) => formatTransactionDate(value),
      },
      {
        Header: "مقدم الخدمة",
        accessor: "serviceProviders.salon_name",
        Cell: ({ value }) => value || 'غير متوفر',
      },
      // {
      //   Header: "المبلغ",
      //   accessor: "total",
      //   Cell: ({ value }) => `${value} ر.س`,
      // },
      {
        Header: "حالة الدفع",
        accessor: "payment_status",
        Cell: ({ value }) => <Status value={value} />,
      },
      {
        Header: "الإجراءات",
        accessor: "action",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <Button
              color="primary"
              size="sm"
              onClick={() => handleRowClick(row.original)}
            >
              عرض التفاصيل
            </Button>
            {/* <Button
              color="success"
              size="sm"
              onClick={() => exportSingleToPDF(row.original)}
            >
              PDF
            </Button> */}
            <Button
              color="info"
              size="sm"
              onClick={() => exportSingleToExcel(row.original)}
            >
              Excel
            </Button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="page-content" dir="rtl">
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <h4 className="card-title mb-4">الحوالات المكتملة</h4>

              {/* <Dropdown isOpen={exportDropdownOpen} toggle={toggleExportDropdown}>
                  <DropdownToggle color="primary" caret>
                    تصدير البيانات
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={exportToExcel}>Excel (الكل)</DropdownItem>
                    <DropdownItem onClick={exportToPDF}>PDF (الكل)</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
       */}
              
              {/* أزرار التصفية السريعة */}
              <div className="mb-3">
                <Button 
                  color={quickFilter === 'الكل' ? 'primary' : 'light'} 
                  className="me-2"
                  onClick={() => applyQuickFilter('الكل')}
                >
                  الكل
                </Button>
                <Button 
                  color={quickFilter === 'اليوم' ? 'primary' : 'light'} 
                  className="me-2"
                  onClick={() => applyQuickFilter('اليوم')}
                >
                  اليوم
                </Button>
                <Button 
                  color={quickFilter === 'الأسبوع' ? 'primary' : 'light'} 
                  className="me-2"
                  onClick={() => applyQuickFilter('الأسبوع')}
                >
                  الأسبوع
                </Button>
                <Button 
                  color={quickFilter === 'الشهر' ? 'primary' : 'light'} 
                  className="me-2"
                  onClick={() => applyQuickFilter('الشهر')}
                >
                  الشهر
                </Button>
                <Button 
                  color="secondary"
                  onClick={toggleDateRangeModal}
                >
                  نطاق مخصص
                </Button>
                {(startDate || endDate) && (
                  <Button color="link" onClick={clearFilters}>
                    مسح الفلتر
                  </Button>
                )}
                 <Button 
                  className="me-2 m-4"
                  color="success"
                  onClick={() => exportToExcel()}
                >
                 تصدير كملف Excel
                </Button>
                
                
              </div>
              
              {/* مؤشر الفلتر النشط */}
              {(startDate || endDate) && (
                <div className="mb-3">
                  <Badge color="info" className="me-2">
                    {startDate ? format(startDate, 'yyyy/MM/dd') : '...'} 
                    {' → '}
                    {endDate ? format(endDate, 'yyyy/MM/dd') : '...'}
                  </Badge>
                  <small className="text-muted">
                    {filteredTransactions.length} معاملة موجودة
                  </small>
                </div>
              )}

              <TableContainer
                columns={columns}
                data={filteredTransactions}
                customPageSize={10}
                className="custom-header-css"
              />
              
              <TransactionModal
                isOpen={isModalOpen}
                toggleModal={toggleModal}
                transaction={selectedTransaction}
              />
              
              {/* نافذة اختيار النطاق الزمني */}
              <Modal isOpen={isDateRangeModalOpen} toggle={toggleDateRangeModal} dir="rtl">
                <ModalHeader toggle={toggleDateRangeModal}>
                  اختر نطاق التاريخ
                </ModalHeader>
                <ModalBody>
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    inline
                    locale={ar}
                    dateFormat="yyyy/MM/dd"
                    isClearable
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={applyDateFilter}>
                    تطبيق
                  </Button>
                  <Button color="secondary" onClick={toggleDateRangeModal}>
                    إلغاء
                  </Button>
                </ModalFooter>
              </Modal>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const Status = ({ value }) => {
  const statusMap = {
    paid: { color: 'success', icon: 'bx bx-check-double', text: 'تم الدفع' },
    pending: { color: 'warning', icon: 'bx bx-time-five', text: 'قيد الانتظار' },
    failed: { color: 'danger', icon: 'bx bx-block', text: 'فشل' }
  };

  const status = statusMap[value] || { color: 'secondary', icon: '', text: value };

  return (
    <Badge color={status.color} className="font-size-12">
      <i className={`${status.icon} align-middle me-1`} />
      {status.text}
    </Badge>
  );
};

export default ResolvedTransferTransactions;